import type { Component } from "solid-js";

/**
 * RouteLoader Component
 *
 * A simple loading indicator shown while lazy-loaded routes are being fetched.
 * Displays a spinning loader with gradient colors matching the app's theme.
 */
const RouteLoader: Component = () => {
  return (
    <div class="flex min-h-screen items-center justify-center bg-black">
      <div class="flex flex-col items-center gap-4">
        {/* Spinner */}
        <div class="h-12 w-12 animate-spin rounded-full border-4 border-gray-700 border-t-purple-500" />

        {/* Loading text */}
        <p class="text-sm font-medium text-gray-400">Loading...</p>
      </div>
    </div>
  );
};

export default RouteLoader;
